import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MatRadioModule } from '@angular/material/radio';

import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { UploadDocumentsPresignedComponent } from './upload-documents-presigned.component';
import { UploadDocumentsPresignedRoutingModule } from './upload-documents-presigned-routing.module';
import { DialogOptionsService } from 'src/app/shared/services/dialog-options.service';

@NgModule({
  declarations: [UploadDocumentsPresignedComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UploadDocumentsPresignedRoutingModule,
    MatInputModule,
    MatRadioModule,
    MatDialogModule
  ],
  providers: [DialogOptionsService]
})
export class UploadDocumentsPresignedModule {}
